export default __webpack_public_path__ + "static/media/who-03.51eab08e.svg";